<template>
  <div id="app">
  <!--
  <vue-cookie-accept-decline
    :ref="'myPanel1'"
    :elementId="'myPanel1'"
    :debug="false"
    :position="'bottom-left'"
    :type="'floating'"
    :disableDecline="false"
    :transitionName="'slideFromBottom'"
    :showPostponeButton="false"
	>
	//>
    <div slot="postponeContent">
        &times;
    </div>

    <div slot="message">
        We use cookies to ensure you get the best experience on our website. <a href="https://cookiesandyou.com/" target="_blank">Learn More...</a>
    </div>

    <div slot="declineContent">
       OPT OUT
    </div>

    <div slot="acceptContent">
        GOT IT!
    </div>
</vue-cookie-accept-decline>
	-->

    <!-- <Modal v-show="showModal" ref="modal"/> -->
    <SolarMap v-show="isMapVisible" @nextPage="showCalc" @loadSaved ="loadSaved" @hideCalc="hideCalc" nonsense="blajblaj"/>
    <SolarCalc v-show="isCalcVisible"/>
	<!--
    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
	-->
	<!--<div id="hiddenDiv" style="display:none;height:300px;">-->
	
	</div>
  </div>
</template>

<script>
//import Modal from './components/Modal.vue';
//<!--import HelloWorld from './components/HelloWorld.vue'
import SolarMap from './components/SolarMap.vue'
import SolarCalc from './components/SolarCalc.vue'

export default {
  name: 'App',
data() {
        return {
		loading: false,
	nonsense: 'blaha',
	//showModal: true,
	roofs: [],
	isCalcVisible: false,
	isMapVisible: true,
		}
		},
  components: {
    SolarMap,
    SolarCalc,
	//Modal
  },
      methods: {
	  getRoofs(){
	  return SolarMap;},
	  
      showCalc(roofs) {
	  this.$root.$refs.SolarCalc.switchPage();
        var calcContainer = document.getElementById('firstCalcContainer');
        calcContainer.style.display = 'block';
	  this.loading = true;
	  this.roofs = roofs;
        this.isCalcVisible = true;
        var element = document.getElementById('topp');
        window.setTimeout(function() {
            element.scrollIntoView({
              behavior: "smooth"
            })
        }, 1000)
	//	var theMap = document.getElementById('app-wrapper');
	//	var divClone = theMap.cloneNode(true);
	//	document.body.appendChild(divClone);
      //  this.isMapVisible = false;
      },
      loadSaved(roofs) {
	  this.$root.$refs.SolarCalc.switchPage('load');
        var calcContainer = document.getElementById('firstCalcContainer');
        calcContainer.style.display = 'block';
	  this.loading = true;
	  this.roofs = roofs;
        this.isCalcVisible = true;
        var element = document.getElementById('topp');
        window.setTimeout(function() {
            element.scrollIntoView({
              behavior: "smooth"
            })
        }, 2000)
      },
      hideCalc() {
	  this.roofs = []
        this.isCalcVisible = false;
      //  this.isMapVisible = false;
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
        this.isMapVisible = true;
      },
	  loadGA(){
	  //console.log("Loading GA");
	  //loadGoogleAnalytics();
	  },
	  checkCookie(){
	  //console.log("Checking....");
	  //this.$refs.myPanel1.removeCookie();
	  }
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>
